import React, { useState } from "react";
import Button from "../../../../UiComponents/Button";
import Modal from "../../../../UiComponents/Modal";
import ProcessorRecovery from "../ProcessorRecovery";

const ProcessorRecoveryButton = ({
    children = "Processor Recovery",    
    primary,
    secondary,
    tertiary,
    small,
    hubs,
    processors,
    onClickCallback,
}) => {

    const [showModal, setShowModal] = useState(false);

    const onClickHandler = () => {
        if (onClickCallback) {
            onClickCallback();
        }
        setShowModal(true);
    }

        
    return (<>

        <Button
            primary={primary}
            secondary={secondary}
            tertiary={tertiary}
            small={small}
            onClick={() => {onClickHandler()}}
        >
            {children}
        </Button>

        <Modal show={showModal} close={() => setShowModal(false)}>
            <ProcessorRecovery
                hubs={hubs}
                processors={processors}
                onClose={() => setShowModal(false)}
            />
        </Modal>
        
    </>);
};

export default ProcessorRecoveryButton;